/* eslint-disable no-undef */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-useless-escape */
/* eslint-disable no-magic-numbers */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import YouTube from 'react-youtube';

import { DeviceType } from 'Type/Device';
import history from 'Util/History';

import BestSellerSlider from './BestSellerSlider';

import './BestSeller.style';

/**
 * Homepage BestSeller
 * @class BestSeller
 * @namespace Component/BestSeller/Component
 */

export function extractVideoID(url) {
  if (!url) {
    return '';
  }
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  const match = url.match(regExp);
  if (match && match[7].length === 11) {
    return match[7];
  }

  return alert('Could not extract video ID.');
}
/** @namespace Mspwa/Component/BestSeller/Component/BestSellerComponent */
export class BestSellerComponent extends PureComponent {
  static propTypes = {
    bestSeller: PropTypes.object,
    device: DeviceType.isRequired,
  };

  static defaultProps = {
    bestSeller: [{}],
  };

  onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }

  render() {
    const {
      bestSeller: {
        bestSellers = [],
        newProduct = {},
        saleProduct = {},
        bottomBanner = [],
      },
    } = this.props;

    const bottomBannerLeft = bottomBanner[0] || {};
    const bottomBannerRight = bottomBanner[1] || {};

    const opts = {};
    return (
      <section className='CardContainerBestSeller'>
        <div block='CardContainerBestSeller' elem='Title'>
          Offers Just For You
        </div>
        <div className='CardsComponent'>
          <CardLeft {...saleProduct} />
          <div className='CardsComponent-CardCenter'>
            <BestSellerSlider bestSellers={bestSellers} />
          </div>
          <CardRight {...newProduct} />
          <div className='CardsComponent-CardBottomLeft'>
            <YouTube
              videoId={extractVideoID(bottomBannerLeft.url)}
              opts={opts}
              onReady={this.onReady}
            />
          </div>
          {/* <div
                        className="CardsComponent-CardBottomLeft"
                        onClick={() => {
                            window.open(bottomBannerLeft.url);
                        }}
                    >
                        <img
                            className="CardsComponent-CardBottomLeft-Img"
                            src={bottomBannerLeft.image}
                            alt="Banner"
                        />
                    </div> */}
          <div
            className='CardsComponent-CardBottomRight'
            onClick={() => {
              history.push(bottomBannerRight.url);
            }}>
            <img
              className='CardsComponent-CardBottomRight-Img'
              src={bottomBannerRight.image}
              alt='Banner'
            />
          </div>
        </div>
      </section>
    );
  }
}

export default BestSellerComponent;

export function CardLeft({ image, name, original_price, price, url }) {
  return (
    <div
      className='CardsComponent-CardLeft'
      onClick={() => {
        history.push(url);
      }}>
      <div className='CardsComponent-CardLeft-TopContainer'>
        <div className='CardsComponent-CardLeft-TopContainer-ImgContainer'>
          <img src={image} alt='Snow' />
        </div>
        <button className='CardsComponent-CardLeft-TopContainer-Button'>
          SALE
        </button>
      </div>
      <div className='CardsComponent-CardLeft-Titles'>
        <h1 className='CardsComponent-CardLeft-Titles-Name'>{name}</h1>
        <div className='CardsComponent-CardLeft-Titles-Price'>
          <h1 className='CardsComponent-CardLeft-Titles-Price-Left'>
            {original_price}
          </h1>
          <h1 className='CardsComponent-CardLeft-Titles-Price-Right'>
            {price}
          </h1>
        </div>

        <button className='CardsComponent-CardLeft-Titles-Button'>
          BUY NOW
        </button>
      </div>
    </div>
  );
}

export function CardRight({ image, name, original_price, price, url }) {
  return (
    <div
      className='CardsComponent-CardRight'
      onClick={() => {
        history.push(url);
      }}>
      <div className='CardsComponent-CardRight-TopContainer'>
        <div className='CardsComponent-CardRight-TopContainer-ImgContainer'>
          <img src={image} alt='Snow' />
        </div>
        <button className='CardsComponent-CardRight-TopContainer-Button'>
          SALE
        </button>
      </div>
      <div className='CardsComponent-CardRight-Titles'>
        <h1 className='CardsComponent-CardRight-Titles-Name'>{name}</h1>
        <div className='CardsComponent-CardRight-Titles-Price'>
          <h1 className='CardsComponent-CardRight-Titles-Price-Left'>
            {original_price}
          </h1>
          <h1 className='CardsComponent-CardRight-Titles-Price-Right'>
            {price}
          </h1>
        </div>

        <button className='CardsComponent-CardRight-Titles-Button'>
          BUY NOW
        </button>
      </div>
    </div>
  );
}
